/* eslint-disable arrow-body-style */
import http from '@/utils/http';
import { LikeReportParam, ReportParam } from '../types/common';

export const getIMurData: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/market_profile/reports/imur',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

/**
 * 通过 system 类型获取报告
 * 目前的修改覆盖范围:  intelligence_insights | intelligence_iic | game_analysis
 * 通过不同的 systemType 进行区分调用
 * 注意: gameResearch 历史的调用，历史代码走的是上面的接口，现已进行特殊处理
 * @param systemType intelligence_insights | intelligence_iic | game_analysis
 * @returns
 */
export const getReportBySystemTypeApi: (systemType: string, params?: { resource_ids?: string[]; order_bys?: string[] }) => Promise<any> = (systemType, params) => {
  return http({
    url: `/api/v1/intelligence_pc/report/list`,
    method: 'post',
    data: {
      ...params,
      system: systemType,
    },
  }) as Promise<any>;
};

export const getReportByIdApi = (params: { resource_ids?: string[]; order_bys?: string[] }) => {
  return http({
    url: `/api/v1/intelligence_pc/report/list`,
    method: 'post',
    data: {
      ...params,
      systems: [
        'intelligence_ai',
        'intelligence',
        'intelligence_insights',
        'intelligence_iic',
        'gameResearch',
      ],
    },
  }) as Promise<any>;
};

// export const getInsightsReportListApi: () => Promise<any> = () => {
//   return http({
//     url: `/api/v1/util/resource/intelligence_insights`,
//     method: 'get',
//     data: {},
//     headers: { 'Cache-Control': 'no-cache' },
//   }) as Promise<any>;
// };

// export const getInsightsCenterLibraryReportListApi: () => Promise<any> = () => {
//   return http({
//     url: `/api/v1/util/resource/intelligence_iic`,
//     method: 'get',
//     data: {},
//   }) as Promise<any>;
// };

// export const getGameAnalysisReportListApi: () => Promise<any> = () => {
//   return http({
//     url: `/api/v1/util/resource/game_analysis`,
//     method: 'get',
//     data: {},
//   }) as Promise<any>;
// };

// export const getGameResearchReportSegment: () => Promise<any> = () => {
//   return http({
//     url: `/api/v1/util/resource/gameResearch/segment`,
//     method: 'get',
//     data: {},
//   }) as Promise<any>;
// };

// 点赞、转发、浏览量计数
export const setLikeInsightsReport: (params: LikeReportParam) => Promise<any> = (params) => {
  return http({
    url: `api/v1/util/like`,
    method: 'post',
    data: {
      ...params,
      // 默认点赞数传 like ，传 forward 时为转发数，传 watch 为浏览量
      action_type: params?.action_type || 'like',
    },
  }) as Promise<any>;
};

export const getViewReportApi: (params: ReportParam) => Promise<any> = (params) => {
  return http({
    url: `/api/v1/util/studiohub/resource/report/watched`,
    method: 'post',
    data: {
      ...params,
    },
  }) as Promise<any>;
};

// 查看用户对studio报告是否有权限
export const getStudioPermission = (payload: { studio_code: string }): Promise<any> => {
  return http({
    url: '/api/v2/dashboard/studio/permission',
    method: 'get',
    params: payload,
    rawData: true,
    errorHandler: true,
  });
};

// 是否允许下载报告
export const getReportPermission = (payload: { id: string }): Promise<any> => {
  return http({
    url: `/api/v1/util/resource_info/intelligence_iic/${payload.id}`,
    method: 'get',
    rawData: true,
    errorHandler: true,
  });
};

/** 报告搜索 — 关键词搜索 */
export const searchReportsApi = (params: {
  ai_keyword: string;
  systems: string[];
}): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/report/list',
    method: 'post',
    data: params,
    errorHandler: true,
  });
};

/** 报告搜索 — 联想下拉 */
export const searchReportsPulldownApi = (params: {
  ai_keyword: string;
  page_size: number;
}): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/report/search/pulldown',
    method: 'post',
    data: params,
    errorHandler: true,
  });
};

/** 报告搜索 — 统计概览 */
export const getReportSearchSummaryApi = (): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/report/search/summary',
    method: 'post',
    data: {},
    errorHandler: true,
  });
};

/** 报告搜索 — 热门报告列表 */
export const getPopularReportsApi = (params: {
  systems: string[];
}): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/report/list',
    method: 'post',
    data: {
      ...params,
      is_hot_report: true,
    },
    errorHandler: true,
  });
};
